import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BuildingSurveyViewModel } from "../../Models/buildingTableViewModel";
import { SurveyStatus } from "../../Models/enums/SurveySurveyStatus";

@Component({
  selector: "app-survey-status",
  templateUrl: "./survey-status.component.html",
  styleUrls: ["./survey-status.component.scss"],
})
export class SurveyStatusComponent {
  @Input() data: BuildingSurveyViewModel;
  @Input() allSurveys: BuildingSurveyViewModel[] = [];
  @Output() startSurvey: EventEmitter<any> = new EventEmitter<any>();
  @Output() goToSurvey: EventEmitter<any> = new EventEmitter<any>();
  surveyStatus = SurveyStatus;

  onGoToSurvey(data: any) {
    this.goToSurvey.emit(data);
  }
  onStartSurvey(data: any) {
    this.startSurvey.emit(data);
  }

  displaySurveyStatus(data: BuildingSurveyViewModel): SurveyStatus {
    if (data.surveyStatus == SurveyStatus.OutsideOnGoing && data.isPrefill)
      return SurveyStatus.Prefill;
    return data.surveyStatus;
  }
}
